import styled from 'styled-components';
import { constants } from '@thecb/components';

export const TableWrapper = styled.table`
  background: ${constants.colors.WHITE};
  width: 100%;
  border-spacing: 0;
  box-shadow:
    0px 1px 4px 2px rgba(0, 0, 0, 0.1),
    0px 2px 1px 0px rgba(0, 0, 0, 0.15);
  margin-top: 1rem;
  color: ${constants.colors.CHARADE_GREY};
  font-size: 1rem;
`;

export const TableHeaderWrapper = styled.thead``;
export const TableHeaderCellWrapper = styled.th`
  background: ${constants.colors.ATHENS_GREY};
  margin: 0;
  padding: 1.5rem 1rem;
  border-bottom: 1px solid ${constants.colors.GREY_CHATEAU};
  text-align: left;
  font-weight: ${constants.fontWeights.FONT_WEIGHT_BOLD};

  :last-child {
    padding-right: 0;
    border-right: 0;
  }
`;
export const TableCellWrapper = styled.td`
  margin: 0;
  padding: 1.5rem 1rem;
  border-bottom: 1px solid ${constants.colors.GREY_CHATEAU};
  text-align: left;

  :last-child {
    border-right: 0;
    padding-right: 0;
  }
`;
export const TableRowWrapper = styled.tr`
  :last-child {
    td {
      border-bottom: 0;
    }
  }
`;
export const TableBody = styled.tbody``;
export const PaginationWrapper = styled.div`
  background: ${constants.colors.WHITE};
  width: 100%;
  margin: 0 auto;
  margin-top: 1rem;
  padding: 1.5rem;
  box-shadow:
    0px 1px 4px 2px rgba(0, 0, 0, 0.1),
    0px 2px 1px 0px rgba(0, 0, 0, 0.15);

  font-size: 1rem;

  button {
    min-width: 2.5rem;
  }

  button:last-child,
  button:first-child {
    line-height: 1rem;
  }
`;

export const FiltersWrapper = styled.div``;
